import { Clear as ClearIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { memo, useCallback } from "react";

interface SearchTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  onKeyPress: (event: React.KeyboardEvent) => void;
  onClear: () => void;
  placeholder?: string;
}

const SearchTextField: React.FC<SearchTextFieldProps> = memo(
  ({
    value,
    onChange,
    onKeyPress,
    onClear,
    placeholder = "Search organizations, facilities, projects, and sources... (Press Enter to search)",
  }) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
      },
      [onChange]
    );

    return (
      <Box sx={{ mb: 3 }}>
        <TextField
          fullWidth
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyPress={onKeyPress}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: value && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={onClear}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "background.default",
            },
          }}
        />
      </Box>
    );
  }
);

SearchTextField.displayName = "SearchTextField";

export default SearchTextField;
